import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {UpdateNicknameResultVo} from '../../common/shared/api/nicolas/vo/UpdateNicknameVo.interface';

/**
 * 닉네임 변경
 *
 * Origin: pageNicolasApi.updateNickname
 * API: POST /api/v2/store/update/nickname
 */
export async function postStoreUpdateNickname(
  params: {
    nickname: string;
  },
  options?: FetcherOptions
): Promise<UpdateNicknameResultVo> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v2/store/update/nickname',
    {
      method: 'POST',
      data: {
        nickname: params.nickname,
      },
    },
    options
  );
  return response.data;
}
